import { useCurrentUser } from '@/react/hooks/useUser';

import { PageHeader } from '@@/PageHeader';

import { ScopedKubeconfigsDatatable } from './components/ScopedKubeconfigsDatatable';
import { useAllScopedKubeconfigs } from './queries/useAllScopedKubeconfigs';
import { useEnvironmentNames } from './queries/useEnvironmentNames';

/**
 * Scoped kubeconfigs across every environment. One component serves two places:
 * Administration, where an admin sees everyone's, and the account page, where a
 * user sees their own. The API decides which, so the difference is only wording.
 */
export function GlobalScopedKubeconfigsView() {
  const { isPureAdmin } = useCurrentUser();

  const scopedKubeconfigsQuery = useAllScopedKubeconfigs();
  const environmentNames = useEnvironmentNames();

  return (
    <>
      <PageHeader
        title="Scoped kubeconfigs"
        breadcrumbs={[{ label: 'Scoped kubeconfigs' }]}
        reload
      />

      <ScopedKubeconfigsDatatable
        dataset={scopedKubeconfigsQuery.data ?? []}
        isLoading={scopedKubeconfigsQuery.isLoading}
        tableKey="global-scoped-kubeconfigs"
        showOwner={isPureAdmin}
        showEnvironment
        environmentNames={environmentNames}
        description={
          isPureAdmin
            ? 'Every read-only kubeconfig issued across all environments, by any user.'
            : 'Read-only kubeconfigs you have been issued, across all environments.'
        }
      />
    </>
  );
}
